import { LogoutOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Menu } from 'antd';
import Icon from 'components/util-components/Icon';
import { AUTH_PREFIX_PATH } from 'configs/AppConfig';
import { LOGGED_IN_USER_NAME } from 'constants/AuthConstant';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { signOut } from 'store/slices/authSlice';
import './NavProfile.css';

const handleUserLogout = navigate => {
	sessionStorage.clear();
	navigate(`${AUTH_PREFIX_PATH}/login`);
};

const MenuItem = props => (
	<Link className="d-flex align-items-center" to={props.path}>
		<Icon className="font-size-md" type={props.icon} />
		<span className="font-weight-normal mx-2">{props.label}</span>
	</Link>
);

const MenuItemSignOut = props => (
	<span className="d-flex align-items-center">
		<LogoutOutlined className="font-size-md" />
		<span className="font-weight-normal mx-2">{props.label}</span>
	</span>
);

export const NavProfile = () => {
	const dispatch = useDispatch();

	// Get first name directly from sessionStorage
	const firstName = sessionStorage.getItem(LOGGED_IN_USER_NAME) || 'User';

	const handleClick = ({ key }) => {
		if (key === 'Sign Out') {
			handleSignOut();
		}
	};

	const handleSignOut = () => {
		dispatch(signOut());
	};

	const menu = (
		<Menu
			onClick={handleClick}
			items={[
				{
					key: 'Sign Out',
					label: (
						<div className="user-dropdown-footer">
							<Link to="/logout" style={{ textDecoration: 'none' }}>
								<button className="logout-button">
									<LogoutOutlined />
									<span>Logout</span>
								</button>
							</Link>
						</div>
					),
				},
			]}
		/>
	);

	return (
		<Dropdown placement="bottomRight" overlay={menu} trigger={['click']}>
			<div className="nav-profile-item">
				<div className="user-profile-chip">
					<Avatar className="user-profile-avatar" src="/img/avatars/icon.jpg" />
					<div className="profile-text-wrapper">
						<div className="user-profile-date">{moment().format('dddd, MMMM DD, YYYY')}</div>
						<div className="user-profile-name">Welcome, {firstName}</div>
					</div>
				</div>
			</div>
		</Dropdown>
	);
};

export default NavProfile;
